import { render, staticRenderFns } from "./input_sk_kolektif_pembatalan.vue?vue&type=template&id=4c9cf357&"
import script from "./input_sk_kolektif_pembatalan.vue?vue&type=script&lang=js&"
export * from "./input_sk_kolektif_pembatalan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports